import React from "react";
// Button import unused now that the "Upgrade now" button below is commented out — kept
// here (not removed) matching the same convention as everything else this button pulls in.
// import { Box, Button, Fade, Typography, useTheme } from "@mui/material";
import { Box, Fade, Typography, useTheme } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// eslint-disable-next-line no-unused-vars
import { setSelectedOption } from "../../redux/Slice/Settings/settingsSlice";

function formatDate(dateValue) {
  if (!dateValue) return "";
  return new Date(dateValue).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}

const TrialBanner = () => {
  const theme = useTheme();
  // eslint-disable-next-line no-unused-vars
  const navigate = useNavigate();
  // eslint-disable-next-line no-unused-vars
  const dispatch = useDispatch();
  // eslint-disable-next-line no-unused-vars
  const { accountid } = useParams();
  const isDark = theme.palette.mode === "dark";

  // Reads the subscription data Home.jsx already fetches into Redux (fetchSubscriptionFeatures)
  // instead of fetching /api/subscriptions/me independently here — that used to duplicate the
  // request on every page load since Home.jsx dispatches the same fetch on mount.
  const subscription = useSelector((state) => state.subscription.subscription);
  const planCodeFromSlice = useSelector((state) => state.subscription.planCode);

  const status = subscription?.status;
  const planCode = planCodeFromSlice || subscription?.planCode;
  // cycleEnd is always kept current by admin; trialEnd may be stale — prefer cycleEnd
  const trialEnd = subscription?.cycleEnd || subscription?.trialEnd;

  // Show banner when on trial plan (any status) OR when status is trial/expired
  const isTrialAccount = planCode === "trial" || status === "trial" || status === "expired";

  let bannerState = null;
  if (isTrialAccount && trialEnd) {
    const now = new Date();
    const end = new Date(trialEnd);
    const daysLeft = Math.ceil((end - now) / (1000 * 60 * 60 * 24));
    bannerState = {
      type: daysLeft > 0 ? "active" : "expired",
      daysLeft: Math.max(0, daysLeft),
      trialEnd: end,
    };
  }

  if (!bannerState) return null;

  const isExpired = bannerState.type === "expired";

  const bgColor = isDark ? "#2b2b2b" : "#33383f";
  const accentColor = isExpired ? "#f6ad37" : (isDark ? "#4FC389" : "#4FC389");
  const Icon = isExpired ? WarningAmberIcon : InfoIcon;

  const daysLeftText = `${bannerState.daysLeft} day${bannerState.daysLeft === 1 ? "" : "s"}`;
  const dateText = formatDate(bannerState.trialEnd);

  return (
    <Fade in timeout={400}>
      <Box
        sx={{
          width: "100%",
          minHeight: 52,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: { xs: 2, sm: 3 },
          px: { xs: 2.5, sm: 3.5, md: 4 },
          py: 1.5,
          backgroundColor: bgColor,
          boxSizing: "border-box",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, minWidth: 0 }}>
          <Box
            sx={{
              display: { xs: "none", sm: "flex" },
              alignItems: "center",
              justifyContent: "center",
              width: 30,
              height: 30,
              borderRadius: "50%",
              flexShrink: 0,
              backgroundColor: `${accentColor}22`,
            }}
          >
            <Icon sx={{ fontSize: "1.05rem", color: accentColor }} />
          </Box>
          <Icon sx={{ fontSize: "1.05rem", color: accentColor, flexShrink: 0, display: { xs: "block", sm: "none" } }} />
          <Typography
            sx={{
              color: "rgba(255,255,255,0.92)",
              fontWeight: 500,
              fontSize: { xs: "0.78rem", sm: "0.85rem" },
              whiteSpace: { xs: "normal", sm: "nowrap" },
            }}
          >
            {isExpired ? (
              "Your free trial has ended. Upgrade now to avoid service disruption!"
            ) : (
              <>
                Your free trial ends in{" "}
                <Box component="span" sx={{ color: accentColor, fontWeight: 700 }}>
                  {daysLeftText}
                </Box>{" "}
                on{" "}
                <Box component="span" sx={{ color: accentColor, fontWeight: 700 }}>
                  {dateText}
                </Box>
                . Upgrade now to avoid service disruption!
              </>
            )}
          </Typography>
        </Box>

        {/* "Upgrade now" button commented out, not deleted — its target (Settings "Plans"
            page) is itself commented out for the App Store 1.2.1 billing-compliance fix,
            so this was left as a visible-but-inert button. A visible button that does
            nothing when clicked risks confusing a Shopify reviewer/tester (looks broken),
            so hiding it entirely here instead of just disarming its onClick.
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flexShrink: 0 }}>
          <Button
            variant="contained"
            onClick={() => {
              dispatch(setSelectedOption("Plans"));
              navigate(`/home/${accountid}/settings`);
            }}
            sx={{
              borderRadius: "10px",
              textTransform: "none",
              fontWeight: 600,
              fontSize: "0.8rem",
              px: 2.5,
              py: 0.85,
              backgroundColor: isDark ? "#4FC389" : "#44B57C",
              color: "#ffffff",
              boxShadow: "none",
              "&:hover": { backgroundColor: isDark ? "#3aad77" : "#38a06c", boxShadow: "none" },
            }}
          >
            Upgrade now
          </Button>
        </Box>
        */}
      </Box>
    </Fade>
  );
};

export default TrialBanner;
